import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { DSAlert } from './Alert';
import { GenericWCWrapper, Slots } from '../utils';
import { AlertContent } from '@platform-ui/design-system';
export var DSAlertContent = /*#__PURE__*/function (_GenericWCWrapper) {
  _inherits(DSAlertContent, _GenericWCWrapper);

  var _super = _createSuper(DSAlertContent);

  function DSAlertContent() {
    var _this;

    _classCallCheck(this, DSAlertContent);

    _this = _super.call(this, AlertContent);

    _defineProperty(_assertThisInitialized(_this), "slotName", Slots.body);

    _defineProperty(_assertThisInitialized(_this), "parentName", DSAlert.name);

    return _this;
  }

  return DSAlertContent;
}(GenericWCWrapper);

_defineProperty(DSAlertContent, "_props", ['key'].concat(_toConsumableArray(Object.keys(AlertContent['__docgenInfo'].props))));
//# sourceMappingURL=AlertContent.js.map